import type { NextPage } from 'next'
import Head from 'next/head'
import React, { useEffect } from 'react'
import Announcements from '../components/home/announcements/announcements.component'
import CampaignPanel from '../components/home/campaign/campaign.component'
import FeaturedNewsPanel from '../components/home/featuredNews/featuredNews.component'
import HomePagePopupWrapper from '../components/home/popup/homePagePopupWrapper.component'
import { useAppContext } from '../context/siteMapContext'

const Home: NextPage = () => {
  const { mainData, highContrastOn } = useAppContext()
  const { accessibilityShown } = useAppContext()

  return (
    <>
      <Head>
        <meta property="og:title" content="Budapest 18 kerület önkormányzati weboldal" />
        <meta property="og:image" content="https://webteszt.bp18app.hu/body/logo.jpg" />
        <meta property="og:description" content={mainData.sloganTop_HU} />
        <title>Budapest 18. Kerület</title>
        <meta
          name='description'
          content='Budapest Főváros XVIII. kerület Pestszentlőrinc-Pestszentimre Önkormányzata weboldal, BP18, BP18 App, 18. kerület önkormányzati weboldal, Bp18 Egyesített Óvoda, Kondor Béla Közösségi Ház, Tomory Lajos Múzeum,'
        />
        <meta name='viewport' content='initial-scale=1.0, width=device-width' />
        <link rel='icon' href='/favicon.ico' />
      </Head>
      {!!mainData.campaign && (
        <>
          <CampaignPanel campaign={mainData.campaign} />
          {highContrastOn && (mainData.announcements) && <div className='mx-[-22px] h-[6px] bg-white' />}
        </>
      )}
      {!!mainData.announcements && !!mainData.announcements?.length && (
        <>
          <Announcements announcements={mainData.announcements} />
        </>
      )}
      {!!mainData.popUp && accessibilityShown && <HomePagePopupWrapper data={mainData.popUp} />}
    </>
  )
}

export default Home
